import { render, staticRenderFns } from "./releEntpEntity.vue?vue&type=template&id=3ea12c13&scoped=true&"
import script from "./releEntpEntity.vue?vue&type=script&lang=js&"
export * from "./releEntpEntity.vue?vue&type=script&lang=js&"
import style0 from "./releEntpEntity.vue?vue&type=style&index=0&id=3ea12c13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea12c13",
  null
  
)

component.options.__file = "releEntpEntity.vue"
export default component.exports